import { getEntityRef } from "@client/content/lib/helper";
import { makeFieldStyleSelector } from "@client/content/modules/selectors";
import { makeModuleApiInfoSelector } from "@client/content/selectors";
import { type RootContainerProps } from "@client/content/types";
import { getNoImageUrl } from "@client/lib/assets";
import { TargetSelector, getSettingValueSelector } from "@client/selectors";
import { type AppState } from "@client/types";
import { connect } from "react-redux";
import { adjustOrder, placeOrder, prepareGetOrderInfo, setOrder } from "../actions";
import {
  localStateSelector,
  makeAddressSelector,
  makeCanPlaceOrderSelector,
  makeOrderInfoTriggerParamsSelector
} from "../selectors";
import { type Checkout } from "../types";
import Component, { type ActionProps, type MapProps } from "./component";

const makeMapStateToProps = () => {
  const canPlaceOrderSelector = makeCanPlaceOrderSelector();
  const fieldStyleSelector = makeFieldStyleSelector();
  const isSideBarSelector = getSettingValueSelector(TargetSelector.Entity, "sidebar");
  const consentLocationSelector = getSettingValueSelector(TargetSelector.Entity, "location", "consent");
  const orderInfoTriggerParamsSelector = makeOrderInfoTriggerParamsSelector();
  const addressSelector = makeAddressSelector();

  return (state: AppState, props: RootContainerProps): MapProps => {
    const localState = localStateSelector(state, props);
    const apiInfoSelector = makeModuleApiInfoSelector();

    return {
      ...props,
      apiInfo: apiInfoSelector(state, props),
      billingAddress: addressSelector(state, { id: props.id, isBilling: true }),
      canPlaceOrder: canPlaceOrderSelector(state, props),
      cart: localState.cart,
      consentLocation: consentLocationSelector(state, props),
      error: localState.error,
      event: localState.event,
      failureReason: localState.failureReason,
      fieldStyle: fieldStyleSelector(state, props),
      isSideBar: isSideBarSelector(state, props),
      noImageUrl: getNoImageUrl(),
      orderId: localState.orderId,
      orderInfoTriggerParams: orderInfoTriggerParamsSelector(state, props),
      requiresShipping: localState.cart.requiresShipping,
      shippingAddress: addressSelector(state, { id: props.id, isBilling: false }),
      shippingRuleId: localState.shippingRuleId,
      shippingRules: localState.cart.shippingRules!,
      shouldAdjust: localState.shouldAdjust,
      shouldPay: localState.cart.dueAmount > 0 || localState.cart.hasSubscription,
      status: localState.status
    };
  };
};

const mapDispatchToProps = (dispatch: any, props: RootContainerProps): ActionProps => ({
  onAdjustOrder: () => dispatch(adjustOrder({ id: props.id, source: props.source })),
  onPlaceOrder: (data: Checkout.Order) => dispatch(placeOrder({ id: props.id, source: props.source }, data)),
  onPrepareOrderInfo: (data: Checkout.AdjustOrderInfo, coupons: string[] | null) =>
    dispatch(prepareGetOrderInfo({ id: props.id, source: props.source, ...data }, coupons)),
  setOrder: (order: Checkout.Order) => dispatch(setOrder(getEntityRef(props), order))
});

export default connect(makeMapStateToProps, mapDispatchToProps)(Component);
